export default "__VITE_ASSET__olvDwH4r__"